import { createContext, useContext, useState, useEffect } from "react";
import { configData } from "./config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const app_url = configData.APP_URL;
    const checkLoginStatus = async () => {
        try {
            const response = await fetch(app_url + "site/userdetail", {
                credentials: "include", 
            });

            if (response.ok) return await response.json();
            return null;
        } catch (error) {
            console.error("Error checking login status:", error);
            return null;
        }
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyLogin = async () => {
            const data = await checkLoginStatus();
            if (data?.user) {
                setUser(data.user);
                localStorage.setItem("user", JSON.stringify(data.user));
            } 
            setTimeout(() => {
                setLoading(false);
            }, 200);
        };
        verifyLogin();
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, loading, setLoading }}>
        {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};